import { OrganizationData } from "./types";

/**
 * Checks if an organization has completed onboarding
 *
 * Note: Onboarding questions (business_type, advertising_audience, etc.) were removed
 * in favor of a streamlined flow. Organizations are now considered "onboarded" immediately
 * after creation. This function always returns true for any valid organization.
 */
export function isOnboardingComplete(organization: OrganizationData): boolean {
  // Any valid organization is considered onboarded
  return !!organization;
}

/**
 * Determines the correct post-authentication redirect path based on organization onboarding status
 */
export function getPostAuthRedirect(organization: OrganizationData): string {

  if (!organization) {
    throw new Error("Organization is required for post-authentication navigation");
  }

  const redirectPath = isOnboardingComplete(organization) ? "/business" : "/welcome";

  return redirectPath;
}

/**
 * Gets the redirect path for incomplete onboarding (welcome flow)
 */
export function getOnboardingRedirectPath(): string {
  return "/welcome";
}
